/**
 * 获取二级评论列表
 * @param comment_id 评论ID
 * @param page 分页
 * @returns 二级评论列表
 */
export async function fetchCommentReplyList(
  comment_id: number,
  page: number
): Promise<CommentSecondReplyDetail[]> {
  return http
    .get<CommentSecondReplyDetail[]>('/v1/comment/reply_list', {
      comment_id,
      page,
      html: 1
    })
    .then((res) => {
      return res.data?.filter((item) => item.is_delete === false) || []
    })
}
